import React from 'react';

import './FamilyDinnerItem.css';

const FamilyDinnerItem = ({ title, price, tags, items }) => (
    <div className='app__menuitem'>
      <div className='app__menuitem-head'>
        <div className='app__menuitem-name' >
          <p className='p__cormorant' style={{ color: '#DCCA87', fontSize: '32px', paddingTop: '10px', paddingBottom: '10px'}}>{title}</p>
        </div>
  
        <div className='app__menuitem-dash'></div>
  
        <div className='app__menuitem-price'>
          <p className='p__cormorant' style={{fontSize: '27px'}}>{price}</p>
        </div>
      </div>
  
      <div className='app__menuitem-sub'>
    
        <ul>
          {items.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
        <p className='p__opensans' style={{ color: '#AAA', marginTop: '0.5rem' }}>{tags}</p>
      </div>
    </div>
  );
  

export default FamilyDinnerItem;
